const MODULE = document.querySelectorAll('[data-module="todas_solucoes_cards"]');

class SolucoesCardsGlobal {
    constructor() {
        this.components = MODULE;
        this.init();
    }

    init() {
        this.components.forEach(component => {
            const select = component.querySelector('.solucoes-select');

            if (!select) return;

            select.addEventListener('change', (event) => {
                const url = event.target.value;

                if (url) {
                    window.location.href = url;
                }
            });
        });
    }
}

(() => {
    if (MODULE.length) {
        new SolucoesCardsGlobal();
    }
})();

export default SolucoesCardsGlobal;